import { useParams } from "react-router-dom";

const useTokenIdParam = () => {
  const { tokenId } = useParams<{ tokenId: string }>();
  return tokenId ? parseInt(tokenId, 10) : undefined;
};

export default useTokenIdParam;
